/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/lib/performance"/>

export const now = Date.now;